// extracted by mini-css-extract-plugin
export default {"label":"TextArea_label__lNpnl","input":"TextArea_input__939s3","error":"TextArea_error__fYNaq","eye":"TextArea_eye__0t-a4"};